import * as Yup from 'yup';
import { DateTime } from 'luxon';

import { parseDateString } from './utils';

const eighteenYearsAgo = DateTime.now().minus({ years: 18 }).toJSDate();

type Schemas = {
    [key: string]: Yup.ObjectSchema;
};

const schemas: Schemas = {
    personalDetails: Yup.object({
        name: Yup.string(),
        email: Yup.string(),
        phoneNumber: Yup.string(),
        dateOfBirth: Yup.date()
            .required('Date of Birth | This field is required.')
            .transform(parseDateString)
            .typeError('Date of Birth | Date must be in the format DD/MM/YYYY.')
            .max(
                eighteenYearsAgo,
                'Date of Birth | You must be at least 18 years old to register.',
            ),
    }),
    preferences: Yup.object({
        specialities: Yup.array(),
        specialitiesOther: Yup.string(),
        languages: Yup.array(),
        languagesOther: Yup.string(),
    }),
    professionalDetails: Yup.object({
        medicalIndemnityOrganisation: Yup.string().required(
            'Please state your Medical Indemnity Organisation | This field is required.',
        ),
    }),
    supportingDocumentation: Yup.object({
        files: Yup.array(
            Yup.object({
                category: Yup.string(),
            }),
        ).test('contains-required', '', function test(files) {
            if (!Array.isArray(files)) return false;
            const requiredFiles = ['PROOF_OF_RIGHT_TO_WORK', 'PROOF_OF_INDEMNITY'];
            const missingFiles = requiredFiles.filter(
                (category) => !files.some((file: any) => file?.category === category),
            );
            if (missingFiles.length > 0) {
                throw this.createError({
                    message: `Supporting documentation | ${missingFiles.join(',')}`,
                });
            }
            return true;
        }),
    }),
    declaration: Yup.object({
        confirmCorrect: Yup.boolean()
            .required()
            .oneOf(
                [true],
                'I confirm that the information I have provided is correct and understand that misleading statements may be sufficient grounds for cancelling any agreements made | You must check this box to continue.',
            ),
        confirmUnansweredFollowup: Yup.boolean()
            .required()
            .oneOf(
                [true],
                'I understand that questions left unanswered or partially answered may be discussed following this application | You must check this box to continue.',
            ),
        receiveMarketing: Yup.boolean(),
    }),
};

export default schemas;
